import { differenceInDays, format, formatDistance, isPast, isToday } from 'date-fns';
import { addMonths, isAfter, isBefore, setDate, subMonths } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';

import { default as timezoneHolder } from '@townsquare/date-utils/timezone-holder';
import { minusMonths, tzDate } from '@townsquare/date-utils/utils';

export const GOALS_MONTH_START_DATE = 8;
export const GOALS_MONTH_END_DATE = 7;

export const getCurrentGoalMonthRange = () => {
  const currentDate = tzDate();
  let endOfGoalMonthDate = setDate(currentDate, GOALS_MONTH_END_DATE);
  let startOfGoalMonthDate = setDate(currentDate, GOALS_MONTH_START_DATE);

  // 5pm on the 7th of the Month.
  endOfGoalMonthDate.setHours(17, 0, 0, 0);
  // midnight on the 8th of the month
  startOfGoalMonthDate.setHours(0, 0, 0, 0);

  // First week of the month, last week of the goal month.
  if (isBefore(currentDate, setDate(currentDate, GOALS_MONTH_START_DATE))) {
    startOfGoalMonthDate = subMonths(startOfGoalMonthDate, 1);
  } else {
    endOfGoalMonthDate = addMonths(endOfGoalMonthDate, 1);
  }

  return { startOfGoalMonthDate, endOfGoalMonthDate };
};

export const isThisGoalMonth = (date: Date) => {
  const { startOfGoalMonthDate, endOfGoalMonthDate } = getCurrentGoalMonthRange();
  return isAfter(date, startOfGoalMonthDate) && isBefore(date, endOfGoalMonthDate);
};

export const isLastGoalMonth = (date: Date) => {
  const { startOfGoalMonthDate, endOfGoalMonthDate } = getCurrentGoalMonthRange();
  const startOfLastGoalMonth = minusMonths(startOfGoalMonthDate, 1);
  const endOfLastGoalMonth = minusMonths(endOfGoalMonthDate, 1);
  return isAfter(date, startOfLastGoalMonth) && isBefore(date, endOfLastGoalMonth);
};

export const isGoalUpdatedThisMonth = (lastUpdateDateString?: string | null): boolean => {
  const date = tzDate(lastUpdateDateString);
  return !!lastUpdateDateString && isThisGoalMonth(date);
};

export const calculateGoalUpdateDueDate = (lastUpdateDateString?: string | null): Date => {
  const { endOfGoalMonthDate } = getCurrentGoalMonthRange();
  return isGoalUpdatedThisMonth(lastUpdateDateString) ? addMonths(endOfGoalMonthDate, 1) : endOfGoalMonthDate;
};

export const formatDueDate = (dueDate: Date, locale: Locale): string => {
  // Oops missed the update! Due now!
  if (isPast(dueDate) || isToday(dueDate)) {
    return `Next update due today`;
    // If over four weeks away show the exact date
  } else if (differenceInDays(dueDate, tzDate()) >= 28) {
    return `Next update due ${format(dueDate, 'do LLLL')}`;
  } else {
    return `Next update due in ${formatDistance(dueDate, utcToZonedTime(Date.now(), timezoneHolder.getUserTimezone()), {
      locale,
    })}`;
  }
};
